var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarsProgress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M488 32H24C10.75 32 0 44 0 59V133C0 148 10.75 160 24 160H488C501.25 160 512 148 512 133V59C512 44 501.25 32 488 32ZM464 112H352V80H464V112ZM488 352H24C10.75 352 0 364 0 379V453C0 468 10.75 480 24 480H488C501.25 480 512 468 512 453V379C512 364 501.25 352 488 352ZM464 432H288V400H464V432ZM488 192H24C10.75 192 0 204 0 219V293C0 308 10.75 320 24 320H488C501.25 320 512 308 512 293V219C512 204 501.25 192 488 192ZM464 272H160V240H464V272Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarsProgress);
export default __webpack_public_path__ + "static/media/bars-progress.304bf59312e3439ef9dfcdc44ffca089.svg";
export { ForwardRef as ReactComponent };